import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

// Import Swiper components and modules
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

// Import Swiper core styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import tsm from "../../assets/tsm.png"; // Example local image import

export default function MediaGallery() {
  // Track which video is currently playing to toggle between cover image and iframe
  const [playingVideoId, setPlayingVideoId] = useState(null);


   const getYoutubeEmbedUrl = (url) => {
      if (!url) return "";
  
      let videoId = "";
  
      if (url.includes("youtu.be/")) {
        videoId = url.split("youtu.be/")[1].split("?")[0];
      } else if (url.includes("watch?v=")) {
        videoId = url.split("watch?v=")[1].split("&")[0];
      } else if (url.includes("/embed/")) {
        return url;
      }
  
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    };
    
  // Mixed Media Gallery Array (FIXED URLs)
  const mediaItems = [
    {
      id: 1,
      type: "image",
      url: tsm,
      title: "Our Modern Workspace Architecture",
    },
    {
      id: 2,
      type: "video",
      coverUrl: tsm,
      videoUrl: "https://youtu.be/2PuFyjAs7JA?si=EeYN9tN6sGUpbKBC",
      title: "TSM Corporate Overview Video",
    },
    {
      id: 3,
      type: "image",
      url: tsm,
      title: "Collaborative Agile Team Sessions",
    },
    {
      id: 4,
      type: "video",
      coverUrl: tsm,
      videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
      title: "Cloud Scalability Architecture Summit",
    },
  ];

  return (
    <section
      id="media-gallery"
      className="py-5"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <Container className="py-5">
        {/* Header Block */}
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <h6
              className="text-primary text-uppercase fw-bold mb-2 small"
              style={{ letterSpacing: "1px" }}
            >
              VISUAL SHOWCASE
            </h6>
            <h2 className="fw-bold text-dark display-6 mb-3">
              Media & Video Gallery
            </h2>
            <p className="text-secondary px-lg-5 fs-6">
              Browse through our corporate image gallery and click to play live
              featured video productions in a unified interface.
            </p>
          </Col>
        </Row>

        {/* Swiper Slider Wrapper */}
        <div className="position-relative px-md-5">
          <Swiper
            modules={[Pagination, Navigation, Autoplay]}
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            autoplay={{
              delay: 4500,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }}
            pagination={{ clickable: true, el: ".gallery-pagination" }}
            navigation={{ nextEl: ".gallery-next", prevEl: ".gallery-prev" }}
            breakpoints={{
              768: { slidesPerView: 2 }, // Show 2 slides on tablets
            }}
            className="w-100 rounded-3 shadow-sm overflow-hidden"
          >
            {mediaItems.map((item) => (
              <SwiperSlide key={item.id}>
                <div
                  className="position-relative overflow-hidden bg-black w-100 d-flex align-items-center justify-content-center"
                  style={{ height: "380px" }}
                >
                  {/* CONDITION 1: Render Static Image */}
                  {item.type === "image" && (
                    <>
                      <img
                        src={item.url}
                        alt={item.title}
                        className="w-100 h-100"
                        style={{ objectFit: "cover" }}
                      />
                      <div
                        className="position-absolute bottom-0 start-0 w-100 p-4 text-white"
                        style={{
                          background:
                            "linear-gradient(transparent, rgba(0,0,0,0.8))",
                          zIndex: 2,
                        }}
                      >
                        <h5 className="fw-bold mb-0 fs-6">
                          <i className="bi bi-image me-2"></i> {item.title}
                        </h5>
                      </div>
                    </>
                  )}

                  {/* CONDITION 2: Render Interactive Video Slide */}
                  {item.type === "video" && (
                    <div className="w-100 h-100 position-relative">
                      {playingVideoId === item.id ? (
                        /* Embedded iframe video player */
                        <iframe
                          src={getYoutubeEmbedUrl(item.videoUrl)}
                          title={item.title}
                          className="w-100 h-100 border-0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        />
                      ) : (
                        /* Video Poster Cover Layout */
                        <>
                          <img
                            src={item.coverUrl}
                            alt={item.title}
                            className="w-100 h-100 opacity-75"
                            style={{ objectFit: "cover" }}
                          />

                          {/* Centered Play Button Trigger */}
                          <Button
                            variant="primary"
                            className="position-absolute top-50 start-50 translate-middle rounded-circle d-flex align-items-center justify-content-center border-0 shadow-lg"
                            style={{
                              width: "64px",
                              height: "64px",
                              backgroundColor: "#f06548",
                              zIndex: 3,
                            }}
                            onClick={() => setPlayingVideoId(item.id)}
                          >
                            <i className="bi bi-play-fill fs-3 text-white ms-1"></i>
                          </Button>

                          <div
                            className="position-absolute bottom-0 start-0 w-100 p-4 text-white"
                            style={{
                              background:
                                "linear-gradient(transparent, rgba(0,0,0,0.8))",
                              zIndex: 2,
                            }}
                          >
                            <h5 className="fw-bold mb-0 fs-6">
                              <i className="bi bi-play-circle me-2"></i>{" "}
                              {item.title}
                            </h5>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Slider Navigation Buttons */}
          <div
            className="gallery-prev position-absolute top-50 start-0 translate-middle-y z-3 cursor-pointer d-none d-md-flex align-items-center justify-content-center bg-white rounded-circle shadow"
            style={{ width: "44px", height: "44px" }}
          >
            <i className="bi bi-chevron-left text-dark"></i>
          </div>
          <div
            className="gallery-next position-absolute top-50 end-0 translate-middle-y z-3 cursor-pointer d-none d-md-flex align-items-center justify-content-center bg-white rounded-circle shadow"
            style={{ width: "44px", height: "44px" }}
          >
            <i className="bi bi-chevron-right text-dark"></i>
          </div>

          {/* Slider Pagination Indicators */}
          <div className="gallery-pagination d-flex justify-content-center gap-2 mt-4"></div>
        </div>
      </Container>
    </section>
  );
}
